import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRenovatebotComponent } from './simple-icons-renovatebot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRenovatebotComponent ],
    exports:      [ SimpleIconsRenovatebotComponent ],
    bootstrap:    []
})
export class SimpleIconsRenovatebotModule {}
